import { render, staticRenderFns } from "./MenuCaregiver.vue?vue&type=template&id=5125dae9&"
import script from "./MenuCaregiver.vue?vue&type=script&lang=js&"
export * from "./MenuCaregiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports